import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../core/settings.service';
import {Cookie} from '../helper/cookie';

@Injectable()
export class PaymentService {
  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService,
    private router: Router
  ) {}

  getPaymentDetail(id: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'payments/' + id.toString() + '/detail'
    );
  }

  createPayment(id: number) {
    const cookies = new Cookie();
    const refCode = cookies.getCookie('ref_code');

    const body = {
      id: id
    };

    if (refCode !== undefined) {
      body['refCode'] = refCode;
    }

    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'payment/add',
      body
    );
  }

  createPaymentStripe(id: number, token: string) {
    const cookies = new Cookie();
    const refCode = cookies.getCookie('ref_code');

    const body = {
      id: id,
      token: token
    };

    if (refCode !== undefined) {
      body['refCode'] = refCode;
    }

    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'payment/stripe/add',
      body
    );
  }

  createPaymentSubscriptionStripe(id: number, params: any = {}) {
    const cookies = new Cookie();
    const refCode = cookies.getCookie('ref_code');

    const body = {
      id: id
    };

    if (refCode !== undefined) {
      body['refCode'] = refCode;
    }

    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'payment/subscription/stripe/add',
      body
    );
  }

  trackFacebookConversion(orderId: number) {
    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'facebook/conversion/purchase/' + orderId.toString(),
      {}
    );
  }

  redirectAfterPayment(userState) {
    if (userState.user !== null) {
      if (userState.user.type === -1 || userState.user.username.indexOf('@trial.auditor') >= 0) {
        if (userState.user.username.indexOf('@trial.auditor') >= 0) {
          setTimeout(() => {
            this.router.navigate(['/user/register']);
          }, 3000);
        } else {
          setTimeout(() => {
            this.router.navigate(['/user/register/type']);
          }, 3000);
        }
      } else {
        setTimeout(() => {
          this.router.navigate(['/audits']);
        }, 3000);
      }
    }
  }
}
